import { shouldShowDevTool } from '@/components/DevTool/DevTool';
import { logAPICall } from '@/components/DevTool/devToolEventStore';
import { AxiosError } from 'axios';
import Config from 'react-native-config';
// Global logging control flags
let isAPILoggingEnabled = Config.ENABLE_DEVTOOL === 'true';
export const setAPILogging = (enabled) => {
    isAPILoggingEnabled = enabled;
};
export const logDebug = (...args) => {
    if (__DEV__) {
        console.log(...args);
    }
};
// Store for tracking request timing
const requestTimestamps = new Map();
// 요청별 DevTool 로그 id — 요청 시 PENDING row를 만들고, 응답/에러에서 같은 id로 갱신해
// row가 2개로 쌓이지 않게 한다.
const requestLogIds = new Map();
export const logRequest = (config) => {
    if (!isAPILoggingEnabled)
        return;
    const { method, url, data, headers } = config;
    const requestKey = `${method}-${url}`;
    const timestamp = Date.now();
    const logId = `${timestamp}-${Math.random()}`;
    // Store timestamp for duration calculation
    requestTimestamps.set(requestKey, timestamp);
    requestLogIds.set(requestKey, logId);
    console.log('🚀 API Request:', {
        method: method === null || method === void 0 ? void 0 : method.toUpperCase(),
        url,
        data,
        headers: headers,
    });
    // Send to DevTool if enabled
    if (shouldShowDevTool()) {
        logAPICall({
            id: logId,
            method: (method === null || method === void 0 ? void 0 : method.toUpperCase()) || 'UNKNOWN',
            url: url || '',
            requestHeaders: headers,
            requestBody: data,
            timestamp,
        });
    }
};
export const logResponse = (response) => {
    var _a;
    if (!isAPILoggingEnabled)
        return;
    const { status, data, config, headers } = response;
    const requestKey = `${config.method}-${config.url}`;
    const endTime = Date.now();
    const startTime = requestTimestamps.get(requestKey);
    const duration = startTime ? endTime - startTime : undefined;
    const logId = requestLogIds.get(requestKey);
    // Clean up timestamp
    requestTimestamps.delete(requestKey);
    requestLogIds.delete(requestKey);
    console.log('✅ API Response:', {
        status,
        url: config.url,
        data,
    });
    // Send to DevTool if enabled
    if (shouldShowDevTool()) {
        logAPICall({
            id: logId,
            method: ((_a = config.method) === null || _a === void 0 ? void 0 : _a.toUpperCase()) || 'UNKNOWN',
            url: config.url || '',
            requestHeaders: config.headers,
            requestBody: config.data,
            responseStatus: status,
            responseHeaders: headers,
            responseBody: data,
            duration,
            timestamp: startTime || endTime,
        });
    }
};
export const logError = (error, context) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    if (!isAPILoggingEnabled)
        return;
    if (error instanceof AxiosError) {
        const requestKey = `${(_a = error.config) === null || _a === void 0 ? void 0 : _a.method}-${(_b = error.config) === null || _b === void 0 ? void 0 : _b.url}`;
        const endTime = Date.now();
        const startTime = requestTimestamps.get(requestKey);
        const duration = startTime ? endTime - startTime : undefined;
        const logId = requestLogIds.get(requestKey);
        // Clean up timestamp
        requestTimestamps.delete(requestKey);
        requestLogIds.delete(requestKey);
        let errorTitle = '';
        if (error.name === 'CanceledError') {
            errorTitle = '🚧 API Aborted:';
        }
        else {
            errorTitle = '❌ API Error:';
        }
        console.error(errorTitle, {
            context,
            status: (_c = error.response) === null || _c === void 0 ? void 0 : _c.status,
            url: (_d = error.config) === null || _d === void 0 ? void 0 : _d.url,
            data: (_e = error.response) === null || _e === void 0 ? void 0 : _e.data,
            message: error.message,
        });
        // Send to DevTool if enabled
        if (shouldShowDevTool()) {
            logAPICall({
                id: logId,
                method: ((_g = (_f = error.config) === null || _f === void 0 ? void 0 : _f.method) === null || _g === void 0 ? void 0 : _g.toUpperCase()) || 'UNKNOWN',
                url: ((_h = error.config) === null || _h === void 0 ? void 0 : _h.url) || '',
                requestHeaders: (_j = error.config) === null || _j === void 0 ? void 0 : _j.headers,
                requestBody: (_k = error.config) === null || _k === void 0 ? void 0 : _k.data,
                responseStatus: (_l = error.response) === null || _l === void 0 ? void 0 : _l.status,
                responseHeaders: (_m = error.response) === null || _m === void 0 ? void 0 : _m.headers,
                responseBody: (_o = error.response) === null || _o === void 0 ? void 0 : _o.data,
                error: `${error.message}${context ? ` (${context})` : ''}`,
                duration,
                timestamp: startTime || endTime,
            });
        }
    }
    else if (error instanceof Error) {
        console.error('❌ Error:', {
            context,
            name: error.name,
            message: error.message,
            stack: error.stack,
        });
    }
    else {
        console.error('❌ Unknown Error:', {
            context,
            error,
        });
    }
};
